import { render, staticRenderFns } from "./autherXy.vue?vue&type=template&id=0c7ae948&scoped=true"
import script from "./autherXy.vue?vue&type=script&lang=js"
export * from "./autherXy.vue?vue&type=script&lang=js"
import style0 from "./autherXy.vue?vue&type=style&index=0&id=0c7ae948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ae948",
  null
  
)

export default component.exports